import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './index_rem.js'
import { AppContextProvider, colorPrimary } from '@utils/AppContext';
import { ConfigProvider, message } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import "./i18n/config";
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');


// 重写message.error方法：msg为空时不弹出error消息框，解决-4001重复弹框的问题
const originErrorFunc = message.error
const originWarningFunc = message.warning
const originInfoFunc = message.info
message.error = msg => msg && originErrorFunc(msg)
message.warning = msg => msg && originWarningFunc(msg)
message.info = msg => msg && originInfoFunc(msg) 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
    <ConfigProvider locale={zhCN} theme={{token: { colorPrimary }}}>
      <AppContextProvider>
        <App />
      </AppContextProvider>      
    </ConfigProvider>

    </BrowserRouter>
);

reportWebVitals((res) => {
  // console.log(res.name, res.value)
});
